export default "__VITE_ASSET__973b8df0__"